import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@smartplatform/ui';

export const CreateNew = ({ link, name }) => {
	return (
		<Link to={link}>
			<Button label={`${name}`} />
		</Link>
	);
};
